import { useCallback } from 'react';
import { useMap } from 'react-leaflet';
import { useNetworkElementsStore } from '../../store/networkElementsStore';
import { useNetworkMapStore } from '../../store/networkMapStore';
import { AnyNetworkElement } from '../../types/network';
import { calculateMapBounds } from './mapBounds';
import L from 'leaflet';

/**
 * Button to re-center the map on the current zone's network elements.
 * Positioned below Leaflet's native zoom controls (top-left).
 */
export function FitZoneButton() {
  const map = useMap();
  const elements = useNetworkElementsStore(state => state.elements) as AnyNetworkElement[];
  const setMapPosition = useNetworkMapStore(state => state.setMapPosition);

  const handleFitZone = useCallback(() => {
    if (elements.length === 0) return;

    const points = calculateMapBounds(elements);
    if (points.length === 0) return;

    const bounds = L.latLngBounds(points);
    const center = bounds.getCenter();

    map.fitBounds(bounds, {
      padding: [100, 100],
      maxZoom: 22,
      animate: true
    });

    setMapPosition({
      center: [center.lat, center.lng],
      zoom: map.getZoom() || 18.5
    });
  }, [map, elements, setMapPosition]);

  if (elements.length === 0) return null;

  return (
    <div className="leaflet-top leaflet-left" style={{ top: 80 }}>
      <div className="leaflet-control leaflet-bar">
        <a
          role="button"
          title="Auf Zone zoomen"
          aria-label="Auf Zone zoomen"
          className="flex! items-center! justify-center! w-[30px]! h-[30px]! leading-none! cursor-pointer hover:bg-gray-100 bg-white text-gray-700 border-0"
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleFitZone();
          }}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ display: 'block' }}
          >
            <circle cx="11" cy="11" r="7" />
            <path d="M21 21l-4.35-4.35" />
            <path d="M8 11h6M11 8v6" />
          </svg>
        </a>
      </div>
    </div>
  );
}
